<template>
  <div class="targeting-wrapper">
    <Gdtv3TargetingForm class="ghost-button-styles" ref="targetingFormRef" is-add> </Gdtv3TargetingForm>

    <div class="submit-btns">
      <el-button @click="onFormCancel">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onFormSubmit">提交</el-button>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router/composables'
import Gdtv3TargetingForm from './components/gdtv3/targeting-form.vue'
import { useTargetingFormSubmit, useTargetingFormEdit } from './hooks/useGdtv3Targeting.js'
import { getInitForm } from './components/gdtv3/useGdtv3TargetingForm.js'
import { onMounted } from 'vue'

const route = useRoute()
const router = useRouter()

const { targetingFormRef, onFormSubmit, submitLoading, onFormCancel } = useTargetingFormSubmit(router, getInitForm)
const { initFormEdit } = useTargetingFormEdit(targetingFormRef)

// 进入编辑页面
onMounted(() => {
  const { targetingId, t } = route.query
  if (targetingId && t) {
    initFormEdit(targetingId, t)
  } else {
    targetingFormRef.value.setForm(getInitForm())
  }
})
</script>

<style lang="scss" scoped>
.targeting-wrapper {
  height: calc(100% - 40px);
  padding-top: 80px;
  overflow: hidden;
  overflow-y: auto;
  position: relative;

  .el-form {
    width: 1420px;
    margin: 0 auto;

    .inventory_types {
      .check-all {
        margin-right: 30px;
      }
      display: flex;
    }
  }
}

.submit-btns {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;
  width: 100%;
  text-align: right;
  position: absolute;
  // bottom: 0;
}
</style>
